import { useState } from 'react';
import './App.css';
import { Button, Divider, Flex, Form, Input, message } from 'antd';
import { Typography } from 'antd';
import 'react-quill/dist/quill.snow.css';
import { useNavigate } from 'react-router-dom';

import { LeftCircleOutlined } from '@ant-design/icons';

const { Title, Link } = Typography;

const GetKg = () => {
    const [form] = Form.useForm();
    const [value, setValue] = useState('');
    const n = useNavigate();

    const onConvert = async (values: any) => {
        setValue('');
        const url = values.url;
        const response = await (
            await fetch('https://api.lynne.com.cn/kg/get', {
                method: 'POST',
                body: JSON.stringify({
                    url,
                }),
                headers: new Headers({
                    'Access-Control-Allow-Origin': '*',
                    'Content-type': 'Application/json',
                }),
            })
        ).json();
        if (response.success) {
            message.success('成功喵！');
            setValue(response.message);
        } else {
            message.error(response.message);
        }
    };
    // 渲染数据
    return (
        <>
            <Flex align='center' gap={10}>
                <Button
                    type='primary'
                    shape='circle'
                    icon={<LeftCircleOutlined />}
                    onClick={() => n('/dashboard')}
                />
                <Title level={3} style={{ margin: '15px 0', flex: 1 }}>
                    K歌链接提取~
                </Title>
            </Flex>
            <Divider />
            <Form
                layout='vertical'
                form={form}
                name='new_wiki'
                clearOnDestroy
                onFinish={values => onConvert(values)}>
                <Form.Item
                    name='url'
                    label='全民K歌地址'
                    rules={[
                        {
                            required: true,
                            message: '请输入地址喵',
                            type: 'url',
                        },
                    ]}>
                    <Input />
                </Form.Item>
                <Button type='primary' htmlType='submit'>
                    转换喵！
                </Button>
            </Form>
            {value && <Link href={value}>{value}</Link>}
        </>
    );
};

export default GetKg;
